import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=c2343b4a&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2343b4a')) {
      api.createRecord('c2343b4a', component.options)
    } else {
      api.reload('c2343b4a', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=c2343b4a&", function () {
      api.rerender('c2343b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QYecxdWde148/JS/comp/openstreetmap.vue"
export default component.exports